export default class subscriberGrid {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                repository: '@',
                repositoryAttributes: '=',
                searching: '=',
                removeOnSuppression: '='
            },
            template: require('../../../../views/subscriber/subscriber-grid.html'),
            replace: true,
            compile: function(element, attrs) {
                if (! attrs.removeOnSuppression) {
                    attrs.removeOnSuppression = false;
                }
            },
            controller: function($scope, $state, $filter, $window, $location, $stateParams, $rootScope, $timeout, Subscriber, Events, Tag, Segment, SweetAlert) {
                this.repositoryMap = {
                    subscriber: Subscriber,
                    tag: Tag,
                    segment: Segment
                };

                this.view = $window.localStorage.getItem('settings.subscriber.view_v2') || 'card';
                this.search = '';
                this.lastSearch = '';
                this.currentPage = 1;
                this.totalPages;
                this.loading = !searchInSegment();
                this.simplePagination = false;
                this.fetchedRowsCount = 0;
                this.perPage = 20;
                this.isEventOverview = $state.current.name == 'event.show';
                this.showAllCollections = false;
                this.isNonTagged = $scope.repositoryAttributes.status === 'non-tagged';
                this.selectAll = false;
                this.orderBy = this.isEventOverview ? 'added_to_tag' : 'id';

                this.searchInSegment = searchInSegment;

                this.setPage = () => {

                    if (this.isNonTagged) {
                        this.view = 'list';
                    }
                    if ($scope.searching) {
                        this.searchPage(this.search);
                    } else {
                        this.loading = true;
                        let functionName = $scope.repository == 'subscriber' ? 'allByStatus' : 'subscribers';
                        this.repositoryMap[$scope.repository][functionName](
                            $scope.repositoryAttributes,
                            this.currentPage,
                            this.view,
                            this.orderBy
                        ).then((results) => {
                            this.subscribers = results.data;
                            this.currentPage = results.meta.pagination.current_page;
                            this.totalPages = results.meta.pagination.total_pages;
                            this.fetchedRowsCount = results.meta.pagination.count;
                            this.perPage = results.meta.pagination.per_page;
                            this.simplePagination = typeof results.meta.simple_pagination === "undefined" ?
                                false :
                                results.meta.simple_pagination;
                            this.loading = false;
                        });
                    }
                };

                this.setPage(); // Initial load.

                $scope.$on('subscriber:add:suppression', (event, data) => {
                    Subscriber.suppress(data.subscriberId, data.suppression).then(() => {
                        // subscriber.has_suppressions = true;
                        if ($scope.removeOnSuppression) {
                            angular.forEach(this.subscribers, (value, index) => {
                                if (value.id === data.subscriberId) {
                                    this.subscribers.splice(index, 1);
                                }
                            });
                        }

                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER_MODAL:UNSUBSCRIBE:SUPPRESSED'));
                        $rootScope.$broadcast('subscribersRecount');
                    }, () => {
                        SweetAlert.swal($filter('translate')('SUBSCRIBER_MODAL:UNSUBSCRIBE:SUPPRESSED_FAILED'), "", "error")
                    });
                });

                this.toggleView = () => {
                    this.view = this.view === 'card' ? 'list' : 'card';
                    $window.localStorage.setItem('settings.subscriber.view_v2', this.view); // Remember choice.
                    delete this.currentPage;
                    this.setPage();
                };

                this.showSubscriberEventData = (subscriber) => {
                    $scope.$emit('event:subscriber:showData', subscriber);
                };

                this.searchPage = (search) => {
                    this.loading = true;
                    this.repositoryMap[$scope.repository].search(
                        search,
                        this.currentPage,
                        this.view,
                        $scope.repositoryAttributes,
                        this.orderBy
                    ).then((results) => {
                        this.lastSearch = this.search;
                        this.loading = false;
                        this.fetchedRowsCount = results.meta.pagination.count;
                        if (! results.data.length) {
                            this.noSearchResult = true;
                            this.searchCount = 0;
                            return;
                        }

                        this.noSearchResult = false;

                        this.subscribers = results.data;
                        this.perPage = results.meta.pagination.per_page;
                        this.simplePagination = typeof results.meta.simple_pagination === "undefined" ?
                            false :
                            results.meta.simple_pagination;

                        this.currentPage = results.meta.pagination.current_page;
                        this.totalPages = results.meta.pagination.total_pages;

                        this.searchCount = results.meta.pagination.total;
                    });
                };

                var searchTimeout;

                this.doSearch = () => {

                    if (this.search.length) {
                        if (searchTimeout) {
                            $timeout.cancel(searchTimeout);
                        }

                        $scope.searching = true;
                        this.lastSearch = this.search;

                        searchTimeout = $timeout(() => {
                            this.currentPage = null;
                            this.subscribers = [];
                            this.searchPage(this.search);
                        }, 300);
                    } else {
                        this.resetSearchMode();
                        this.setPage();
                    }

                };

                this.clearSearch = () => {
                    if (this.lastSearch !== '') {
                        this.lastSearch = '';
                        this.resetSearchMode();
                        this.setPage();
                    } else {
                        this.search = '';
                    }
                };

                this.resetSearchMode = () => {
                    $scope.searching = false;
                    delete this.currentPage;
                    this.noSearchResult = false;
                    this.search = null;
                    this.searchCount = 0;
                    this.subscribers = [];
                };

                this.suppress = (subscriber) => {
                    $scope.$broadcast('subscriber:show:suppression', subscriber);
                };

                this.resubscribe = (subscriber, index) => {
                    Subscriber.resubscribe(subscriber.id).then(() => {
                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER_MODAL:RESUBSCRIBED'));
                        this.subscribers.splice(index, 1);
                        $rootScope.$broadcast('subscribersRecount');
                    });
                };

                this.toggleSelectAll = () => {
                    angular.forEach(this.subscribers, (subscriber) => {
                        subscriber.selected = this.selectAll;
                    });
                };

                this.deleteSubscribers = () => {
                    let subscribersSelected = this.getSelectedSubscribersIds();

                    if (subscribersSelected.length) {
                        SweetAlert.swal({
                                title: $filter('translate')('SUBSCRIBER_MODAL:MASS_DELETE:TITLE'),
                                text: $filter('translate')('SUBSCRIBER_MODAL:MASS_DELETE:DESCRIPTION').replace(':subscribers_count', subscribersSelected.length),
                                type: "warning",
                                customClass: 'sweet-alert--delete',
                                showCancelButton: true,
                                confirmButtonText: $filter('translate')('GLOBAL:YES'),
                                cancelButtonText: $filter('translate')('GLOBAL:NO')
                            }, (isConfirm) => {
                                if (isConfirm) {
                                    Subscriber.massDelete(subscribersSelected).then(() => {
                                        this.reloadNonTaggedView();
                                        $scope.$emit('subscriber:deleted');
                                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER_MODAL:MASS_DELETE:SUCCESS'));
                                    }, () => {
                                        SweetAlert.swal($filter('translate')('SUBSCRIBER_MODAL:DELETE:DELETE_FAILED'), "", "error");
                                    })
                                }
                            }
                        )
                    } else {
                        SweetAlert.swal($filter('translate')('SUBSCRIBER_MODAL:NOT_SELECTED'), "", "error");
                    }
                };

                this.showAddToTagModal = () => {
                    let subscribersSelectedCount = this.countSelectedSubscribers();

                    if (subscribersSelectedCount) {
                        $scope.$broadcast('subscribers:addToTag:show', subscribersSelectedCount);
                    } else {
                        SweetAlert.swal($filter('translate')('SUBSCRIBER_MODAL:NOT_SELECTED'), "", "error");
                    }
                };

                this.massAddToTag = (tags) => {
                    console.log(tags)

                    let subscribersSelected = this.getSelectedSubscribersIds();

                    Subscriber.massAddTags(subscribersSelected, tags).then(() => {
                        this.reloadNonTaggedView();
                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER_MODAL:ADD_TO_TAG:SUCCESS'));
                    }, () => {
                        SweetAlert.swal($filter('translate')('SUBSCRIBER_MODAL:ADD_TO_TAG:FAILED'), "", "error");
                    });
                };

                this.countSelectedSubscribers = () => {
                    let subscribersSelectedCount = 0;
                    angular.forEach(this.subscribers, (subscriber) => {
                        if (subscriber.selected) {
                            subscribersSelectedCount++
                        }
                    });
                    return subscribersSelectedCount;
                };

                this.getSelectedSubscribersIds = () => {
                    let subscribersSelected = [];
                    angular.forEach(this.subscribers, (subscriber) => {
                        if (subscriber.selected) {
                            subscribersSelected.push(subscriber.id);
                        }
                    });
                    return subscribersSelected;
                };

                this.getNotSelectedSubscribers = () => {
                    let subscribersNotSelected = [];
                    angular.forEach(this.subscribers, (subscriber) => {
                        if (!subscriber.selected) {
                            subscribersNotSelected.push(subscriber);
                        }
                    });
                    return subscribersNotSelected;
                };

                this.reloadNonTaggedView = () => {
                    this.subscribers = this.getNotSelectedSubscribers();
                    if (this.subscribers.length === 0) {
                        this.loadMore();
                    }
                    this.selectAll = false;
                };

                this.loadMore = () => {
                    this.currentPage = this.currentPage + 1;
                    if ($scope.searching) {
                        this.searchPage(this.search);
                    } else {
                        let functionName = $scope.repository == 'subscriber' ? 'allByStatus' : 'subscribers';
                        this.repositoryMap[$scope.repository][functionName](
                            $scope.repositoryAttributes,
                            this.currentPage,
                            this.view,
                            this.orderBy
                        ).then((results) => {
                            this.subscribers = this.subscribers.concat(results.data);
                            this.currentPage = results.meta.pagination.current_page;
                            this.totalPages = results.meta.pagination.total_pages;

                            this.fetchedRowsCount = results.meta.pagination.count;
                            this.perPage = results.meta.pagination.per_page;
                            this.simplePagination = typeof results.meta.simple_pagination === "undefined" ?
                                false :
                                results.meta.simple_pagination;
                        })
                    }
                };

                this.goToInformation = (subscriber) => {
                    $state.go('subscriber.show', { id: subscriber.id });
                };

                this.goToFields = (subscriber) => {
                    $state.go('subscriber.show.subFolder', { id: subscriber.id, subFolder: 'customField' });
                };

                this.goToActivity= (subscriber) => {
                    $state.go('subscriber.show.subFolder', { id: subscriber.id, subFolder: 'activity' });
                };

                var reloadListener = $scope.$on('subscriberGrid:reload', () => {
                    delete this.currentPage;
                    this.subscribers = [];
                    this.setPage();
                });

                $scope.$on('subscribers:addToTag:add', (event, tags) => {
                    this.massAddToTag(tags);
                });

                $scope.$on('$destroy', reloadListener);

                function searchInSegment() {
                    return $scope.repository === 'segment';
                }
            },
            controllerAs: 'grid'
        };
    }
};

subscriberGrid.$inject = ['Subscriber'];
